export default __webpack_public_path__ + "static/media/budget.9a0121f5.png";